import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { IDriver } from "@interfaces/IDriver";
import { IUser } from "@interfaces/IUser";
import { AvatarService } from "@services/avatar.service";
import { ConstantsService } from "@services/constantsService";
import { CurrentUserService } from "@services/currentUser.service";
import "./driverImage.scss";

@Component({
    selector: 'driver-image',
    template: require('./driverImage.html')
})

// Issues with driver image not loading!!!!

export class DriverImageComponent implements OnChanges, OnInit {
    @Input() driver: IDriver;
    @Input() small: boolean;

    driverImage = "/assets/images/avatars/profile.jpg";
    currentUser: IUser;
    apiUrl: string;

    constructor(
        private currentUserService: CurrentUserService,
        private avatarService: AvatarService,
        private constantService: ConstantsService) { }

    ngOnInit() {
        this.initialise();
    }

    ngOnChanges() {
        this.updateDriverImage();
    }

    // ---

    private updateDriverImage() {
        this.driverImage = "/assets/images/avatars/profile.jpg";

        if (this.driver && this.driver.Id && this.driver.Id !== -1 && this.driver.HasImage) {
            this.driverImage = `${this.apiUrl}/api/drivers/${this.currentUser?.CurrentAccountUserMapping.AccountId}-${this.driver.Id}/image` + '?' + this.driver.Updated;
        }
        else {
            var driverNameToUse = "?";
            if (this.driver && this.driver.Name && this.driver.Id > 0) {
                driverNameToUse = this.driver.Name;
            }

            this.avatarService
                .getAvatar(driverNameToUse, true, this.small ? 18 : 54)
                .then(imageUrl => {
                    this.driverImage = imageUrl;
                });;
        }
    }

    private initialise() {
        this.currentUserService.getCurrentUser().then(currentUser => {
            this.currentUser = currentUser;
            this.apiUrl = this.constantService.getApiUrl();

            this.updateDriverImage();
        });
    }
}

//import * as angular from "angular";

//import { AvatarService } from "@services/avatar.service";
//import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
//import { IDriver } from "@interfaces/IDriver";

//import "./driverImage.scss";

//interface IDriverImageBindings {
//    driver: IDriver;
//    small: boolean;
//}

//class DriverImageComponentController implements angular.IComponentController, IDriverImageBindings {

//    driver: IDriver;
//    small: boolean;
//    driverImage = "/assets/images/avatars/profile.jpg";

//    static $inject = ["$rootScope", "avatarService", "apiUrl"];

//    constructor(
//        private readonly $rootScope: IRunBlockRootScope,
//        private readonly avatarService: AvatarService,
//        private readonly apiUrl: string) {
//    }

//    $onChanges(onChangesObj: angular.IOnChangesObject) {
//        if (onChangesObj["driver"]) {
//            this.updateDriverImage();
//        }
//    }

//    private updateDriverImage() {
//        this.driverImage = "/assets/images/avatars/profile.jpg";

//        if (this.driver && this.driver.Id && this.driver.Id !== -1 && this.driver.HasImage) {
//            this.driverImage = `${this.apiUrl}/api/drivers/${this.$rootScope.currentUser.AccountId}-${this.driver.Id}/image`;
//        }
//        else {
//            var driverNameToUse = "?";
//            if (this.driver && this.driver.Name && this.driver.Id > 0) {
//                driverNameToUse = this.driver.Name;
//            }

//            this.avatarService
//                .getAvatar(driverNameToUse, true, this.small ? 18 : 54)
//                .then(imageUrl => {
//                    this.driverImage = imageUrl;
//                });;
//        }
//    }
//}

//export class DriverImageComponent implements angular.IComponentOptions {
//    bindings: any;
//    controller: any;
//    template: string;

//    constructor() {
//        this.bindings = {
//            driver: "<",
//            small: "<"
//        };

//        this.controller = DriverImageComponentController;
//        this.template = `<div class="driver-image" ng-style="{'background-image' : 'url('+$ctrl.driverImage+')'}"></div>`;
//    }
//}
